(() => {
  // The vendor inserts cross-origin frames asynchronously. Label only their
  // outer elements; do not inspect messages, personal data or vendor internals.
  const labelFrames = () => {
    document.querySelectorAll('[data-coax-title] iframe').forEach((frame) => {
      const title = frame.closest('[data-coax-title]').dataset.coaxTitle;
      if (frame.title !== title) frame.title = title;
    });
    const chat = document.getElementById('coax-widget-iframe');
    if (chat && !chat.title) chat.title = 'Text Aussie Car Hoists';
  };
  labelFrames();
  new MutationObserver(labelFrames).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
